export default "__VITE_PUBLIC_ASSET__15884bbc__"